import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const QuestionnaireLayoutWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.tone.background};
  height: 100vh;
  display: flex;
  overflow: auto;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 40px 70px;
  @media ${DEVICES.md} {
    padding: 16px 16px 28px 16px;
  }
  @media ${DEVICES.sm} {
    height: 100%;
  }
`;
